module.exports = __webpack_public_path__ + "static/media/1.8a4d139d.png";